module.exports = __webpack_public_path__ + "static/img/user_profile.8ac48b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_profile.png
// module id = MJ1T
// module chunks = 4